// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"92b2c596","260":"4321751a","668":"995cc9c7","762":"28fb418c"}[chunkId] + ".js";
};